import { AssessmentsGradeUpdate } from '@schooly/api';

import {
  AssessmentsGradeForm,
  AssessmentsGradeOptionForm,
} from './SchoolAssessmentsGradeModalContent';

export const convertGradeFormToGradeUpdate = (
  grade: AssessmentsGradeForm,
): AssessmentsGradeUpdate => {
  return {
    ...grade,
    options: grade.options.map(({ has_assessments, ...o }) => ({
      ...o,
      value: o.value ?? 0,
      description: o.description || null,
    })),
  };
};

export const generateAssessmentsGradeListOption: () => AssessmentsGradeOptionForm = () => ({
  name: '',
  value: null,
});
